import React, { useEffect, useRef } from 'react'
import OnVisible from 'react-on-visible'
import { Section } from 'newComponents'
import './styles.scss'

const CodeGist = (props) => {
  const { data, location } = props
  const { primary } = data
  const { code_gist_id: gistId } = primary
  const { text } = gistId
  const id = text
  let iframeNode = useRef()

  useEffect(() => {
    updateIframeContent()
  }, [])

  const containsFileType = id.includes('.js') || id.includes('.java') || id.includes('.php')

  const defineUrl = () => (containsFileType ? `https://gist.github.com/${id}` : `https://gist.github.com/${id}.js`)

  const updateIframeContent = () => {
    const { file } = props
    const iframe = iframeNode
    let doc = iframe.document
    if (iframe.contentDocument) doc = iframe.contentDocument
    else if (iframe.contentWindow) doc = iframe.contentWindow.document

    const gistLink = defineUrl()
    const gistScript = `<script type="text/javascript" src="${gistLink}"></script>`
    const styles = '<style>*{font-size:12px;}</style>'
    const elementId = file ? `gist-${id}-${file}` : `gist-${id}`
    const resizeScript = `onload="parent.document.getElementById('${elementId}').style.height=document.body.scrollHeight + 'px'"`
    const iframeHtml = `<html><head><base target="_parent">${styles}</head><body ${resizeScript}>${gistScript}</body></html>`

    doc.open()
    doc.writeln(iframeHtml)
    doc.close()
  }

  const { file } = props
  const altRender = !location.pathname.includes('blog') ? 'page-variant' : ''
  return (
    <OnVisible className={`gist ${altRender}`}>
      <Section>
        <iframe
          title="Code Gist"
          ref={(n) => {
            iframeNode = n
          }}
          width="100%"
          frameBorder={0}
          id={file ? `gist-${id}-${file}` : `gist-${id}`}
        />
      </Section>
    </OnVisible>
  )
}

export default CodeGist
